// @flow
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import type { ActionType } from './types';
import { dismissAlert } from './actions';
import { getAlertById } from './selectors';
import { getConfig } from '~/core/state/config/selectors';
import handleSaga from '~/core/state/handle-saga';
import type { Effect } from 'redux-saga';
import { REQUEST_ALERT } from './constants';

export function* requestAlertSaga({ payload: { id, isPersistent, expiryMs } }: ActionType): Generator<Effect, *, *> {
    if (isPersistent) {
        return;
    }

    const expiryTimeConfig = yield select(getConfig, 'alerts:expiry');
    const expiryTime = expiryMs || expiryTimeConfig;

    yield call(delay, expiryTime);

    const alert = yield select(getAlertById, id);

    if (alert) {
        yield put(dismissAlert(id));
    }
}

function* watchRequestAlert(): Generator<Effect, *, *> {
    yield takeEvery(REQUEST_ALERT, handleSaga(requestAlertSaga));
}

export default [watchRequestAlert];



// WEBPACK FOOTER //
// ./src/core/state/alerts/sagas.js